<template>
  <v-row class="d-flex align-center justify-center flex-column"> </v-row>
</template>

<script>
export default {
  name: 'Settings',
  components: {},
  data: () => ({}),
  methods: {},
}
</script>

<style></style>
